<section class="form_section">
  <div class="dialog-header">
    <button mat-icon-button (click)="cerrarDialogo()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <h2>Crear Minuta</h2>
  <form
    action=""
    [formGroup]="formRegisterMinute"
    (ngSubmit)="submit()"
    class="form_register_minutes"
  >
    <mat-form-field class="example-form-field">
      <mat-label>Línea de factoring</mat-label>
      <input
        mask="separator"
        thousandSeparator="."
        matInput
        formControlName="line"
      />
    </mat-form-field>
    <mat-form-field class="example-form-field">
      <mat-label>Línea de garantía</mat-label>
      <input 
        formControlName="warrantyLine"
        matInput
        mask="separator"
        thousandSeparator="."
        />
    </mat-form-field>
    
    <mat-form-field class="example-form-field">
      <mat-label>Fecha de Expiración</mat-label>
      <!--<input matInput type="date" formControlName="dueDate" />-->
      <input matInput type='date' [value]="fecha | date:'YYYY-MM-dd'" (input)="onDateChange($event)">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Descripción</mat-label>
      <textarea matInput formControlName="description" placeholder="Describe al cliente y operación a evaluar"> </textarea>
    </mat-form-field>

    <div class="spinner">
      <mat-spinner *ngIf="booleanFlag"  [diameter]="50"></mat-spinner>
    </div>
    <button
      mat-stroked-button
      color="primary"
      class="w-50"
      [disabled]="!formRegisterMinute.valid"
      *ngIf="!booleanFlag"
    >
      Generar Minuta
    </button>
  </form>
</section>
